module.exports = __webpack_public_path__ + "static/media/get-lost-logo.ad869ac2.png";